import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SaveChangingsButton from "./SaveChangingsButton";
import TopHeadingDividerComponent from "./TopHeadingDividerComponent";
const information = [
  { title: "First Name" },
  { title: "Last Name" },
  { title: "Additional Name" },
  { title: "Username" },
  { title: "Birthday" },
  { title: "Phone Number", new: true, placeholder: "Add new phone number" },
  { title: "Email", new: true, placeholder: "Add new email address" },
];
const passwordTextFeildData = [
  { title: "Current Password", width: "621px" },
  { title: "New Password", width: "621px" },
];
function AccountSection() {
  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        p: "20px",
        borderRadius: "20px",
        pb: "100px",
      }}
    >
      <TopHeadingDividerComponent
        primary=" Profile Information"
        secondary="He moonlights difficult engrossed it, sportsmen. Interested has all
        Devonshire difficulty gay assistance joy. Unaffected at ye of compliment
        alteration to."
      />{" "}
      {/* <TextField id="outlined-basic" label="Outlined" variant="outlined" /> */}
      <Stack direction="row" sx={{ flexWrap: "wrap", gap: "24px" }}>
        {information.map((info) => (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {" "}
            <Typography
              variant="body2"
              sx={{
                fontWeight: "400",
                fontSize: "18px",
                lineHeight: "21.78px",
                color: "#696868",
                // pb: "8px",
              }}
            >
              {info.title}
            </Typography>
            <TextField
              variant="outlined"
              sx={{
                width: "400px",
                minWidth: "200px",
                input: {
                  bgcolor: "#ffffff",
                  color: "#696868",
                  fontSize: "18px",
                  boxSizing: "content-box",
                  px: "4px",
                  py: "12px",
                  "&::placeholder": {
                    color: "#696868",
                  },
                },
                "& .MuiOutlinedInput-root": {
                  px: "8px",
                  borderRadius: "12px",
                  bgcolor: "#ffffff",
                  "& fieldset": {
                    border: "1px solid #e3e3e3",
                  }, // Outline color
                  "&:hover fieldset": {
                    border: "1px solid #e3e3e3",
                  }, // Hover state
                  "&.Mui-focused fieldset": {
                    border: "1px solid #e3e3e3",
                  }, // Focus state
                },
              }}
              // InputProps={{
              //   startAdornment: (
              //     <InputAdornment sx={{ pr: "6px" }} position="top">
              //       <SearchIcon sx={{ color: "a2a5b1" }} />
              //     </InputAdornment>
              //   ),
              // }}
            />
            {info.new && (
              <TextField
                variant="outlined"
                placeholder={info.placeholder}
                sx={{
                  width: "400px",
                  input: {
                    bgcolor: "#ffffff",
                    color: "#696868",
                    fontSize: "18px",
                    boxSizing: "content-box",
                    px: "4px",
                    py: "12px",
                    "&::placeholder": {
                      color: "#696868",
                      opacity: 1,
                    },
                  },
                  "& .MuiOutlinedInput-root": {
                    px: "8px",
                    borderRadius: "12px",
                    bgcolor: "#ffffff",
                    "& fieldset": {
                      border: "1px dashed #bababa",
                    }, // Outline color
                    "&:hover fieldset": {
                      border: "1px dashed #bababa",
                    }, // Hover state
                    "&.Mui-focused fieldset": {
                      border: "1px dashed #bababa",
                    }, // Focus state
                  },
                }}
              />
            )}
          </Box>
        ))}
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          py: "60px",
        }}
      >
        {" "}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "18px",
            lineHeight: "21.78px",
            color: "#696868",
            // pb: "8px",
          }}
        >
          Overview
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          multiline
          rows={5} // Set the number of visible lines
          sx={{
            input: {
              bgcolor: "#ffffff",
              color: "#696868",
              fontSize: "18px",
              boxSizing: "content-box",
              px: "4px",
              py: "12px",
              "&::placeholder": {
                color: "#696868",
              },
            },
            "& .MuiOutlinedInput-root": {
              // height: "154px",
              px: "8px",
              borderRadius: "12px",
              bgcolor: "#ffffff",
              "& fieldset": {
                border: "1px solid #e3e3e3",
              }, // Outline color
              "&:hover fieldset": {
                border: "1px solid #e3e3e3",
              }, // Hover state
              "&.Mui-focused fieldset": {
                border: "1px solid #e3e3e3",
              }, // Focus state
            },
          }}
        />
        <SaveChangingsButton>Save Changings</SaveChangingsButton>
      </Box>
      <TopHeadingDividerComponent
        primary="Change your Password"
        secondary="See resolved goodness felicity shy civility domestic had but."
      />{" "}
      <Stack direction="row" sx={{ flexWrap: "wrap", gap: "24px" }}>
        {passwordTextFeildData.map((info) => (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {" "}
            <Typography
              variant="body2"
              sx={{
                fontWeight: "400",
                fontSize: "18px",
                lineHeight: "21.78px",
                color: "#696868",
                // pb: "8px",
              }}
            >
              {info.title}
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              sx={{
                width: info.width,
                input: {
                  bgcolor: "#ffffff",
                  color: "#696868",
                  fontSize: "18px",
                  boxSizing: "content-box",
                  px: "4px",
                  py: "12px",
                  "&::placeholder": {
                    color: "#696868",
                  },
                },
                "& .MuiOutlinedInput-root": {
                  px: "8px",
                  borderRadius: "12px",
                  bgcolor: "#ffffff",
                  "& fieldset": {
                    border: "1px solid #e3e3e3",
                  }, // Outline color
                  "&:hover fieldset": {
                    border: "1px solid #e3e3e3",
                  }, // Hover state
                  "&.Mui-focused fieldset": {
                    border: "1px solid #e3e3e3",
                  }, // Focus state
                },
              }}
            />
          </Box>
        ))}
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          pt: "24px",
        }}
      >
        {" "}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "18px",
            lineHeight: "21.78px",
            color: "#696868",
            // pb: "8px",
          }}
        >
          Confirm Password
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          sx={{
            mb: "16px",
            input: {
              bgcolor: "#ffffff",
              color: "#696868",
              fontSize: "18px",
              boxSizing: "content-box",
              px: "4px",
              py: "12px",

              "&::placeholder": {
                color: "#696868",
              },
            },
            "& .MuiOutlinedInput-root": {
              px: "8px",
              borderRadius: "12px",
              bgcolor: "#ffffff",
              "& fieldset": {
                border: "1px solid #e3e3e3",
              }, // Outline color
              "&:hover fieldset": {
                border: "1px solid #e3e3e3",
              }, // Hover state
              "&.Mui-focused fieldset": {
                border: "1px solid #e3e3e3",
              }, // Focus state
            },
          }}
        />
      </Box>
      <SaveChangingsButton>Update Password</SaveChangingsButton>
    </Stack>
  );
}

export default AccountSection;
